type FormatPhone = {
  value: string;
  oldValue: string;
};

export const formatPhone = ({ value, oldValue = "" }: FormatPhone) => {
  const numericValue = value.replace(/\D/g, "");
  const areaCode = numericValue.slice(0, 3);
  const formattedAreaCode = `(${areaCode}) `;
  const firstThree = numericValue.slice(3, 6);
  const formattedFirstThree = `${firstThree} - `;
  const lastFour = numericValue.slice(6, 10);

  let newValue;

  if (value.length < oldValue.length) {
    newValue = value.replace(/\D/g, "");
  } else {
    newValue = [
      areaCode.length == 3 ? formattedAreaCode : areaCode,
      firstThree.length == 3 ? formattedFirstThree : firstThree,
      lastFour,
    ]
      .filter(Boolean)
      .join("");
  }

  return newValue;
};
